import { Sportsbook } from "../../contracts";
export class AllLeaguesConnection {
    constructor(meta, leaguesHandlers) {
        this.meta = meta;
        this.leaguesHandlers = leaguesHandlers;
    }
    deactivate() {
        this.query = undefined;
    }
    onData(response) {
        if ("updateType" in response && this.leaguesHandlers[response.updateType]) {
            this.leaguesHandlers[response.updateType](response.payload);
        }
        if ("leagues" in response) {
            this.leaguesHandlers.Initial(response);
        }
    }
    onError(error) {
        this.leaguesHandlers.Error(error);
    }
    updateQuery(params) {
        this.query = Sportsbook.queryBuilder.getLeaguesBySportId(params);
    }
}
//# sourceMappingURL=AllLeaguesConnection.js.map